<template>
  <div>
    <v-menu offset-y>
      <!-- profile menu activator -->
      <template v-slot:activator="{ on, attrs }">
        <span
          class="mr-5 ml-5"
          color="white"
          elevation="0"
          v-bind="attrs"
          v-on="on"
        >
          <!-- account icon -->
          <v-icon color="primary" class="mr-2">
            mdi-account-circle
          </v-icon>
          <!-- full name -->
          <span v-show="$vuetify.breakpoint.mdAndUp">
            {{ name }}
          </span>
          <!-- menu icon -->
          <v-icon v-show="$vuetify.breakpoint.mdAndUp">
            mdi-menu-down
          </v-icon>
        </span>
      </template>
      <!-- profile menu item -->
      <v-list>
        <v-list-item  to="/profile">Edit Profile</v-list-item>
        <v-list-item @click="confirmLogout = true">Sign out</v-list-item>
      </v-list>
    </v-menu>

    <!-- logout popup -->
    <base-confirmation-dialog
      v-model="confirmLogout"
      message="Do you want to logout?"
      @confirm="signOut"
      @cancel="confirmLogout = false"
    ></base-confirmation-dialog>
  </div>
</template>

<script>
  export default {
    name: 'AppHeaderMenuProfile',

    props: {
      name: {type: String, default: ' ' }
    },

    data: () => ({
      confirmLogout: false
    }),

    methods: {
      async signOut() {
        this.$store.dispatch('profile/signOut');
      }
    }
  }
</script>